import { DatePipe } from "@angular/common";
import { Injectable, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { appService } from "../../../_services/app.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class OrdersService implements OnInit {
  private customerIdSource = new BehaviorSubject<number | null>(null);
  currentCustomerId = this.customerIdSource.asObservable();
  TenantId: any;
  DeliveryCrossDockList: any = [];
  UOMList: any[] = [];
  Incoterm: any = [];
  PurposeofShipment: any = [];
  Currency: any = [];
  UserList: any = [];
  constructor(
    private _appService: appService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
  }

  setCustomerId(customerId: number) {
    this.customerIdSource.next(customerId); // Update the customerId
  }

  LoadDeliveryCrossDock(TenantId: any): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetById("OrdersByVehicle", "GetDeliveryCrossDock", TenantId)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            this.DeliveryCrossDockList = response;
            resolve(response);
          },
          (err) => {
            var OwnershipError = this.translate.instant(
              "READYTODISPATCH.Erroroccurred"
            );
            this.toastr.error(OwnershipError, "error");
          }
        );
    });
  }

  LoadProductData(SerachValue: any): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetById("OrdersByVehicle", "obv_ProductList", SerachValue)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            this.DeliveryCrossDockList = response;
            resolve(response);
          },
          (err) => {
            var OwnershipError = this.translate.instant(
              "READYTODISPATCH.Erroroccurred"
            );
            this.toastr.error(OwnershipError, "error");
          }
        );
    });
  }

  GetUOMList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetById("Product", "GetUOMListNew", null).subscribe(
        (response) => {
          if (response) {
            response.map((x) => {
              x.name = x.Label;
              x.value = x.Id;
            });
          }
          resolve(response);
          return response;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }

  GetProductCategory(TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Product", "GetCategoryList", TenantId)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetCustomerSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantId(
          "Sales",
          "GetCompanydata",
          SerachValue,
          PageNo,
          TenantId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetPickingStrategy(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "PickingStrategy")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetStorageType(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "GetStorageType")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  AccountTypeSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantId(
          "Product",
          "GetAccountdata",
          SerachValue,
          PageNo,
          TenantId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetGSTTaxGroup(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.Get("Charge", "GetGSTGroupList").subscribe(
        (response) => {
          if (response) {
            response.map((x) => {
              x.name = x.Label;
              x.value = x.Id;
            });
          }
          resolve(response);
          return response;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }

  GetDimensionList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Dimension", "GetDimensionNameList", null)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ProuductSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantId(
          "Product",
          "GetProductForKitdata",
          SerachValue,
          PageNo,
          TenantId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  VendorSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantId(
          "Tyres",
          "GetSupplierName",
          SerachValue,
          PageNo,
          TenantId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getPoOrderNo(type: string, SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId("so_GoodsOutward", "get_POOrderList", type, SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getSoInwardOrderNo(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("so_GoodsOutward", "get_SoInwardOrderList", SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetAirShipOrderNo(CompanyId, TenentId, UserId, SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByFourId("so_GoodsOutward", "GetAirShipOrderNo", CompanyId, TenentId, UserId, SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetAirShipConsignee(CompanyId, TenentId, UserId, SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByFourId("so_GoodsOutward", "GetAirShipConsignee", CompanyId, TenentId, UserId, SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getEANCode(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("so_GoodsOutward", "getEANCode", SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getCustSupplierList(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("so_GoodsOutward", "getCustSupplier", SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ShipperConsigneeSelect1(customerId, SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId(
          "so_GoodsOutward",
          "obv_ShipToPartyList",
          customerId,
          SerachValue
        )
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ShipperConsigneeSelect2(SerachValue, Id, userId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByThreeId(
          "so_GoodsOutward",
          "po_ShipToPartyList",
          userId,
          Id,
          SerachValue
        )
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetCurrencyList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "Currency")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ProuductListSelect2(
    SearchValue,
    CompanyId,
    CustomerID,
    Taxtype,
    Taxable
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByFiveId(
          "OrdersByVehicle",
          "obv_ProductList",
          CompanyId,
          CustomerID,
          Taxtype,
          Taxable,
          SearchValue
        )
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetIncoTerms(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "IncoTerms")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetPurchaseOrderType(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "po_PurchaseOrderType")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Label;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  VehicleNoSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("Expense", "GetVehicleList", SerachValue, PageNo)
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  TransporterSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage(
          "OperationalReport",
          "GetTransporterAdvanceReport",
          SerachValue,
          PageNo
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetIncoterms(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "IncoTerms")
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            this.Incoterm = response;
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  CustomerSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantId(
          "Tyres",
          "GetCustomerList",
          SerachValue,
          PageNo,
          TenantId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ProuductSelect2V2(SerachValue, UserId, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      var obj: any = {};
      obj.SearchValue = SerachValue;
      obj.TenantId = TenantId;
      obj.isCustomer = false;
      obj.useerId = UserId;
      obj.Start = 0;
      obj.PerPage = 1000;

      this._appService.Post("Product", "ProductGetListNew", obj).subscribe(
        (response) => {
          if (response) {
            response.map((x) => {
              x.name = x.ProductName;
              x.value = x.Id;
            });
          }
          resolve(response);
          return response;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }

  GetShipmetpurpose(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "PurposeofShipment")
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            this.PurposeofShipment = response;
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  CustomerSelect2V2(SerachValue, UserId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId("OrdersByVehicle", "obv_CustomerList", UserId, SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetCharge(PageNo, SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoParam("Charge", "GetSelect2AllChargeNew", SerachValue, PageNo)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetDeliveryCrossDockList(TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("OrdersByVehicle", "GetDeliveryCrossDock", TenantId)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetReasonSelect2(SerachValue, PageNo, ReasonFor): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByCustom(
          "ReasonMaster",
          "GetSelect2ReasonList",
          SerachValue,
          PageNo,
          "ReasonFor",
          ReasonFor
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetLocationSelect2(SerachValue, PageNo, Type, CustomerId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByType(
          "OrdersByVehicle",
          "GetLocationCode",
          SerachValue,
          PageNo,
          Type,
          CustomerId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  PickupBranchSelect2(SerachValue, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId("OrdersByVehicle", "GetPickupBranch", TenantId, SerachValue)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ConsigneeSelect2(
    SerachValue,
    PageNo,
    CustomerId,
    DeliveryLocationCode
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryByLocationCode(
          "OrdersByVehicle",
          "obv_GetConsineeName",
          SerachValue,
          CustomerId,
          DeliveryLocationCode
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ShipperSelect2(
    SerachValue,
    PageNo,
    CustomerId,
    DeliveryLocationCode
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryByLocationCode(
          "OrdersByVehicle",
          "obv_GetShipperName",
          SerachValue,
          CustomerId,
          DeliveryLocationCode
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getCountryDetailByPostcode(param, category, parentId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageCategoryNameParentId(
          "Company",
          "GetCountryWiseListData",
          param,
          1,
          category,
          parentId
        )
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  getVehicleType(param, page, NetworkId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageByCustom(
          "VehicleMaster",
          "GetSelect2VehicleList",
          param,
          1,
          "NetworkId",
          NetworkId
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  getProductSelect2(param, page, CustomerID): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageByCustom(
          "OrdersByVehicle",
          "GetProductForOrderdata",
          param,
          1,
          "CustomerID",
          CustomerID
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetUnitList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "UOMProduct")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetTransportServiceList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .Get("OrdersByVehicle", "GetTransportServiceList")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  Getobv_GetShipperName(
    SerachValue,
    PageNo,
    Customer,
    LocationCode
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByFourId(
          "Tyres",
          "Getobv_GetShipperNamet",
          SerachValue,
          PageNo,
          Customer,
          LocationCode
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetLocaitonCodeNew(SerachValue, PageNo, Customer, Type): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByFourId(
          "Tyres",
          "GetLocaitonCodeNew",
          SerachValue,
          PageNo,
          Type,
          Customer
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ReasonSelect2(SerachValue, PageNo, ReasonFor): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByThreeId(
          "ReasonMaster",
          "GetSelect2ReasonListNew",
          SerachValue,
          PageNo,
          ReasonFor
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetCurency(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "Currency")
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            this.Currency = response;
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  Getobv_GetConsineeName(
    SerachValue,
    PageNo,
    Customer,
    LocationCode
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByFourId(
          "Tyres",
          "Getobv_GetConsineeName",
          SerachValue,
          PageNo,
          Customer,
          LocationCode
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetVehicleTypeselect2(param, page): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPage(
          "ManualvehiclePlanning",
          "GetSelect2VehicleData",
          param,
          page
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetBookingVehicleNoSelect2(
    param,
    page,
    TransporterId,
    VehicleTypeId
  ): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageVehicleNo(
          "Booking",
          "VehicleListSelect2",
          param,
          page,
          TransporterId,
          VehicleTypeId
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetDriverSelect2(param, page, TransporterId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageByCustom(
          "Booking",
          "GetDriverList",
          param,
          page,
          "TransporterId",
          TransporterId
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  DriverListSelect2(param, page, TransporterId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageByCustom(
          "Booking",
          "DriverListSelect2",
          param,
          page,
          "TransporterId",
          TransporterId
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  po_rtn_VendorSelect2(userId, SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId(
          "so_GoodsOutward",
          "po_rtn_GetSupplierName",
          userId,
          SerachValue
        )
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetCustomerLisNewV2t(SerachValue, PageNo, TenantId, Type): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantByTwoId(
          "Tyres",
          "GetCustomerLisNewV2t",
          SerachValue,
          PageNo,
          TenantId,
          Type
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getCountryByRateContract(param, customerId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageCountry(
          "Company",
          "GetCountryByRateContract",
          param,
          1,
          customerId
        )
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetCessTaxGroup(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.Get("Charge", "GetCessGroupList").subscribe((response) => {
        if (response) {
          response.map(x => {
            x.name = x.Label;
            x.value = x.Id;
          })
        }
        resolve(response);
        return response;
      },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    })
  }

  //DropDown For User
  GetUserName(SerachValue, page): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("AccountingReport", "NewGetUserDropDown", SerachValue, page)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.value;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  NewGetDriver(SerachValue, page, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantId("OperationalReport", "NewGetDriverList", SerachValue, page, TenantId)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.value;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetReferenceNoList(SerachValue, page): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("OperationalReport", "GetReferenceNoSelect2", SerachValue, page)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.id;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  //For Account Name
  NewAccountNameList(SerachValue, page): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("AccountingReport", "NewGetAccountName", SerachValue, page)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.value;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  NewChargeCodeList(SerachValue, page): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("AccountingReport", "NewGetChargeCode", SerachValue, page)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.value;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }


}
